<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">
				<template v-if="action == 'store'">
					Vuoi aggiungere la pratica?
				</template>
				<template v-else-if="action == 'edit'">
					Vuoi apportare le seguenti modifiche alla pratica?
				</template>
			</span>
		</v-card-title>
		<v-card-text>
			<v-form ref="riepilogoModificheForm" lazy-validation>
				<template v-if="action == 'edit'">
					<template v-for="fase in listaModificheFasi">
						<div class="mt-4 mb-4">
							<div class="font-weight-medium">{{ fase.titolo }}</div>
							<ul>
								<li v-for="campo in fase.campi">
									<span>{{ campo.text }}</span>
									<template v-if="inviaEmailAlCliente || inviaEmailAlReferente">
										<v-icon v-if="campo.send_email" color="success" size="15">mdi-check-bold</v-icon>
										<v-icon v-else color="error" size="15">mdi-close-thick</v-icon>
									</template>
								</li>
								<li v-for="file in fase.files">
									<span>{{ file.text }}</span>
									<template v-if="inviaEmailAlCliente || inviaEmailAlReferente">
										<v-icon v-if="file.send_email" color="success" size="15">mdi-check-bold</v-icon>
										<v-icon v-else color="error" size="15">mdi-close-thick</v-icon>
									</template>
								</li>
							</ul>
						</div>
					</template>
				</template>
				
				<template v-if="action == 'edit' && isAccountManager">
					<v-divider
						class="mb-5 mt-5"
						:style="`background-color: ${$vuetify.theme.currentTheme.primary}`"></v-divider
					>
					
					<v-radio-group
						v-model="opzioneInvioEmail"
						label="Opzioni di invio"
						:rules="[validaOpzioniDiInvio]"
						:disabled="nonCiSonoModificheInviabiliPerEmail"
					>
						<v-radio
							v-for="opzione in opzioniInvioEmail"
							:key="opzione"
							:label="opzione"
							:value="opzione"
						></v-radio>
					</v-radio-group>
					
					<v-divider
						class="mb-5"
						:style="`background-color: ${$vuetify.theme.currentTheme.primary}`"></v-divider
					>
					
					<v-row>
						<v-col>
							<v-checkbox
								v-model="inviaEmailAlCliente"
								label="Inviare email al Cliente?"
								:disabled="invioEmailDisabled"
								:rules="[validateCheckboxes]"
								class="mt-0"
							></v-checkbox>
						</v-col>
						<v-col>
							<v-checkbox
								v-model="inviaEmailAlReferente"
								label="Inviare email al Referente?"
								:disabled="invioEmailDisabled"
								:rules="[validateCheckboxes]"
								class="mt-0"
							></v-checkbox>
						</v-col>
					</v-row>
					
					<v-row class="mt-0">
						<v-col>
							Se il Cliente e il Referente hanno lo stesso indirizzo email, verrà inviata una sola email
						</v-col>
					</v-row>
					
					<v-row v-if="nonCiSonoModificheInviabiliPerEmail" class="mt-0">
						<v-col>
							<div class="error--text font-weight-medium">
								Non ci sono modifiche inviabili via email
							</div>
						</v-col>
					</v-row>
					
					<v-expansion-panels
						v-if="pratica.modifiche_in_coda !== null"
						accordion
						class="mt-4"
					>
						<v-expansion-panel>
							<v-expansion-panel-header color="secondary">
								<span class="white--text font-weight-medium">
									Modifiche in coda - AM:
									{{ pratica.account_manager_che_ha_messo_in_coda_le_modifiche.nome }}
									{{ pratica.account_manager_che_ha_messo_in_coda_le_modifiche.cognome }}
								</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<template v-for="fase in pratica.modifiche_in_coda">
									<div class="mt-4 mb-4">
										<div class="font-weight-medium">{{ fase.titolo }}</div>
										<ul>
											<li v-for="campo in fase.campi">
												<span>{{ campo }}</span>
											</li>
											<li v-for="file in fase.files">
												<span>{{ file }}</span>
											</li>
										</ul>
									</div>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</template>
			</v-form>
			
			<v-dialog
				v-model="dialogCampiNonCompilati"
				scrollable
				persistent
				width="unset"
			>
				<v-card>
					<v-card-title class="py-2 primary">
						<span class="tertiary--text">
							Sono presenti dei campi non compilati
						</span>
					</v-card-title>
					<v-card-text>
						<template v-for="(campiNonCompilati, numeroFase) in listaCampiNonCompilati">
							<div class="font-weight-medium mt-4 ">
								{{ `Campi non compilati nella fase ${numeroFase}` }}
							</div>
							<ul>
								<li v-for="campo in campiNonCompilati">
									{{ campo }}
								</li>
								<!--<li v-for="file in fase.files">-->
								<!--	<span>{{ file.text }}</span>-->
								<!--</li>-->
							</ul>
						</template>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="tertiary"
							class="black--text"
							:disabled="isSaving"
							@click="dialogCampiNonCompilati = false"
						>
							Annulla
						</v-btn>
						<v-btn
							color="secondary"
							:disabled="isLoading || isSaving"
							:loading="isSaving"
							@click="emitUpdateEvent()"
						>
							Salva
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSaving"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				color="secondary"
				@click="handleSaveButton(action)"
				:loading="isSaving"
				:disabled="isLoading || isSaving"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: [
		'pratica',
		'action',
		'praticaDiff',
		'contrattoDiServizioDiff',
		'files',
		'haveFilesBeenModified',
		'isLoading',
		'isSaving'
	],
	
	data() {
		return {
			listaModificheFasiDaInviarePerEmail: [],
			
			inviaEmailAlCliente: false,
			inviaEmailAlReferente: false,
			
			opzioniInvioEmail: [
				'Non inviare',
				'Invia email singola di dettaglio',
				'Non inviare email ma metti in coda le modifiche',
				'Invia email multipla di dettaglio svuotando la coda',
				'Invia email multipla di sintesi svuotando la coda'
			],
			opzioneInvioEmail: null,
			
			dialogCampiNonCompilati: false,
			ciSonoCampiNonCompilati: false,
			listaCampiNonCompilati: {}
		}
	},
	
	watch: {
		invioEmailDisabled(val) {
			if (val === true) {
				this.inviaEmailAlCliente = false;
				this.inviaEmailAlReferente = false;
			}
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			fasiWithStati: 'fasi/fasiWithStati',
			isLoadingStatiWithFasi: 'fasi/isLoading',
			strutturaDatiPratica: 'fasi/strutturaDatiPratica',
			bando: 'shared/bando'
		}),
		strutturaDatiPraticaPerCliente() {
			// Se è un cliente gli mostro solo le modifiche delle fasi dove può apportare modifiche, altrimenti tutte
			const strutturaDatiPraticaPerCliente = { 1: this.strutturaDatiPratica.fasi[1] };
			if (this.bando?.id == 28) strutturaDatiPraticaPerCliente[5] = this.strutturaDatiPratica.fasi[5];
			return strutturaDatiPraticaPerCliente;
		},
		listaModificheFasi() {
			const fasi = this.isCliente ? this.strutturaDatiPraticaPerCliente : this.strutturaDatiPratica.fasi;
			let lista = [];
			
			for (const numeroFase in fasi) {
				if (!this.ciSonoAggiornamentiFase(numeroFase)) continue;
				
				let campi = {};
				fasi[numeroFase]?.campi.forEach(campo => {
					if (campo.ref == 'pratica'
						&& this.praticaDiff.includes(campo.key)
						&& !campo.key.includes('path')
					) {
						campi[`${campo.key}_pratica`] = {
							text: null,
							send_email: campo.send_email
						}
						
						// inserisco le voci relative alle modifiche degli stati delle fasi
						if (campo.key.includes('id_stato_fase')) {
							campi[`${campo.key}_pratica`].text = `Stato aggiornato: ${fasi[numeroFase].stati.find(stato => stato?.id == this.pratica[`id_stato_fase_${numeroFase}`]).nome}`;
						}
						// inserisco gli altri campi
						else {
							campi[`${campo.key}_pratica`].text = `Campo "${campo.label}" aggiornato`;
						}
					}
					
					if (campo.ref == 'contratto_di_servizio'
						&& this.contrattoDiServizioDiff.includes(campo.key)
						&& !campo.key.includes('path')
					) {
						campi[`${campo.key}_contratto_di_servizio`] = {
							text: null,
							send_email: campo.send_email
						}
						
						campi[`${campo.key}_contratto_di_servizio`].text = `Campo "${campo.label}" aggiornato (Contratto di Servizio)`;
					}
				})
				
				let files = {};
				fasi[numeroFase]?.files?.forEach(file => {
					if (this.haveFilesBeenModified[file.key]) {
						files[file.key] = {
							text: null,
							send_email: file.send_email
						}
						
						files[file.key].text = `File "${file.label}" aggiornato`;
					}
				})
				
				lista.push({
					titolo: `Fase ${numeroFase} ${fasi[numeroFase].nome}`,
					campi: campi,
					files: files,
				})
			}
			
			this.setListaModificheFasiDaInviarePerEmail(lista);
			
			return lista;
		},
		invioEmailDisabled() {
			return this.nonCiSonoModificheInviabiliPerEmail
				|| this.opzioneInvioEmail == null
				|| this.opzioneInvioEmail == 'Non inviare'
				|| this.opzioneInvioEmail == 'Non inviare email ma metti in coda le modifiche'
		},
		nonCiSonoModificheInviabiliPerEmail() {
			let nonCiSonoModificheInviabili = true;
			
			this.listaModificheFasi.forEach(fase => {
				for (const campoKey in fase.campi) {
					if (fase.campi[campoKey].send_email) nonCiSonoModificheInviabili = false;
				}
				
				for (const fileKey in fase.files) {
					if (fase.files[fileKey].send_email) nonCiSonoModificheInviabili = false;
				}
			})
			
			return nonCiSonoModificheInviabili;
		},
		validateCheckboxes() {
			return this.invioEmailDisabled
				|| this.inviaEmailAlReferente
				|| this.inviaEmailAlCliente
				|| "Seleziona almeno un' opzione"
		},
		validaOpzioniDiInvio() {
			return this.nonCiSonoModificheInviabiliPerEmail
				|| this.opzioneInvioEmail !== null
				|| "Seleziona un'opzione"
		}
	},
	
	methods: {
		ciSonoAggiornamentiFase(numeroFase) {
			// this.$_.pluck è una funzione di vue-underscore che crea un array prendendo i valori delle chiavi 'key'
			const praticaKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[numeroFase].campi.filter(campo => campo.ref == 'pratica'), 'key');
			const thereAreModificationsInPratica =  this.praticaDiff.filter(value => praticaKeys.includes(value)).length > 0;
			
			const contrattoDiServizioKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[numeroFase].campi.filter(campo => campo.ref == 'contratto_di_servizio'), 'key');
			const thereAreModificationsInContrattoDiServizio = this.contrattoDiServizioDiff.filter(value => contrattoDiServizioKeys.includes(value)).length > 0;
			
			const filesKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[numeroFase].files, 'key');
			const thereAreModifiedFiles = Object.entries(this.haveFilesBeenModified)
				.filter(([key, value]) => value === true && filesKeys.includes(key))
				.length > 0;
			
			return thereAreModificationsInPratica || thereAreModificationsInContrattoDiServizio || thereAreModifiedFiles;
		},
		close() {
			this.$emit('close');
		},
		setListaModificheFasiDaInviarePerEmail(listaModificheFasi) {
			listaModificheFasi.forEach(fase => {
				let fasePerInvioEmail = {
					titolo: fase.titolo,
					campi: [],
					files: []
				}
				
				let ciSonoModificheInviabiliNeiCampi = Object.values(fase.campi).some(campo => campo.send_email);
				if (ciSonoModificheInviabiliNeiCampi) {
					Object.values(fase.campi)
						.filter(campo => campo.send_email)
						.forEach(campo => {
							fasePerInvioEmail.campi.push(campo.text);
						})
				}
				
				let ciSonoModificheInviabiliNeiFiles = Object.values(fase.files).some(file => file.send_email);
				if (ciSonoModificheInviabiliNeiFiles) {
					Object.values(fase.files)
						.filter(file => file.send_email)
						.forEach(file => {
							fasePerInvioEmail.files.push(file.text);
						})
				}
				
				if (ciSonoModificheInviabiliNeiCampi || ciSonoModificheInviabiliNeiFiles) {
					this.listaModificheFasiDaInviarePerEmail.push(fasePerInvioEmail)
				}
			})
		},
		handleSaveButton(action) {
			if (!this.$refs.riepilogoModificheForm.validate()) return;
			
			if (action == 'store') this.$emit('store')
			else if (action == 'edit') {
				this.gestioneCampiNonCompilati();
				
				if (this.ciSonoCampiNonCompilati) {
					this.dialogCampiNonCompilati = true;
				}
				else {
					this.emitUpdateEvent();
				}
			}
		},
		gestioneCampiNonCompilati() {
			this.listaCampiNonCompilati = {};
			
			const statiDiff = this.praticaDiff.filter(diff => diff.includes('id_stato_fase'));
			
			const statiSelezionati =  Object.keys(this.pratica)
				.filter(key => key.includes('id_stato_fase'))
				.reduce((res, key) => {
					res[key] = this.pratica[key];
					return res;
				}, {});
			
			for (const numeroFase in this.strutturaDatiPratica.fasi) {
				const controlloCampiNonCompilatiAbilitatoNelloStato =
					this.strutturaDatiPratica
						.fasi[numeroFase]
						.stati
						.find(stato => stato?.id == statiSelezionati[`id_stato_fase_${numeroFase}`])
						.controllo_campi_non_compilati_abilitato
				
				if (
					statiDiff.includes(`id_stato_fase_${numeroFase}`) // se è stato modificato lo stato della fase
					&& controlloCampiNonCompilatiAbilitatoNelloStato // se il nuovo stato prevede il controllo dei campi non compilati
				) {
					this.controlloCampiByRef('pratica', numeroFase);
					this.controlloCampiByRef('contratto_di_servizio', numeroFase);
					this.controlloFilesByRef('pratica', numeroFase);
					this.controlloFilesByRef('contratto_di_servizio', numeroFase);
				}
			}
		},
		controlloCampiByRef(ref, numeroFase) {
			const campiDaControllare = this.strutturaDatiPratica
				.fasi[numeroFase]
				.campi
				.filter(campo => campo?.controllo_campo_non_compilato === true)
				.filter(campo => campo.ref === ref);
			
			const chiaviCampiDaControllare = this.$_.pluck(campiDaControllare, 'key'); // ['ragione_sociale', 'codice_identificativo', 'path_modulo_codice_clickday', ...]
			
			const oggetto = ref == 'pratica' ? this.pratica : this.pratica.contratto_di_servizio;
			const chiaviValoreDaControllare = Object.fromEntries(
				Object.entries(oggetto).filter(([key]) => chiaviCampiDaControllare.includes(key))
			);
			
			for (const index in campiDaControllare) {
				const campo = campiDaControllare[index];
				
				if (chiaviValoreDaControllare[campo.key] === null) {
					this.ciSonoCampiNonCompilati = true;
					
					// se non esiste l'array che ha come chiave il numero della fase lo creo
					if (!this.listaCampiNonCompilati.hasOwnProperty(numeroFase)) {
						this.listaCampiNonCompilati[numeroFase] = []
					}
					
					this.listaCampiNonCompilati[numeroFase].push(campo.label);
				}
			}
		},
		controlloFilesByRef(ref, numeroFase) {
			const filesDaControllare = this.strutturaDatiPratica
				.fasi[numeroFase]
				.files
				.filter(campo => campo?.controllo_campo_non_compilato === true)
				.filter(campo => campo.ref === ref);
			
			const chiaviCampiDaControllare = this.$_.pluck(filesDaControllare, 'key'); // ['modulo_codice_clickday', 'modulo_riepilogo', ...]
			
			const oggetto = ref == 'pratica' ? this.pratica : this.pratica.contratto_di_servizio;
			const chiaviValoreDaControllare = Object.fromEntries(
				Object.entries(oggetto).filter(([key]) => {
					// con key.replace rimuovo path_ all'inizio della key altrimenti non posso fare il confronto con chiaviCampiDaControllare
					const keyWithoutPath = key.replace(/^path_/, '');
					
					return chiaviCampiDaControllare.includes(keyWithoutPath);
				})
			);
			
			for (const index in filesDaControllare) {
				const fileDataObj = filesDaControllare[index];
				
				if (
					this.files[fileDataObj.key] === null
					&& chiaviValoreDaControllare[`path_${fileDataObj.key}`] === null
				) {
					
					/**
					 * Caso particolare in cui viene scelto un contratto di servizio già associato a un'altra pratica.
					 * In questo caso la variabile this.pratica.idPraticaConContrattoDiServizio sarà diversa da null
					 * e quindi posso saltare il controllo
 					 */
					if (
						fileDataObj.key == 'contratto_di_servizio'
						&& (
							this.pratica.idPraticaConContrattoDiServizio !== null
							|| chiaviValoreDaControllare[`path_${fileDataObj.key}`] !== null
							|| this.files[fileDataObj.key] !== null
						)
					) continue;
					
					this.ciSonoCampiNonCompilati = true;
					
					// se non esiste l'array che ha come chiave il numero della fase lo creo
					if (!this.listaCampiNonCompilati.hasOwnProperty(numeroFase)) {
						this.listaCampiNonCompilati[numeroFase] = []
					}
					
					this.listaCampiNonCompilati[numeroFase].push(fileDataObj.label);
				}
			}
		},
		emitUpdateEvent() {
				this.$emit('update', {
					listaModificheFasiDaInviarePerEmail: this.listaModificheFasiDaInviarePerEmail,
					inviaEmailAlCliente: this.inviaEmailAlCliente,
					inviaEmailAlReferente: this.inviaEmailAlReferente,
					opzioneInvioEmail: this.opzioneInvioEmail
				})
		},
	}
}
</script>

<style scoped>

</style>